import { createFileRoute, Outlet } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AdminGuard = lazy(() =>
  import("@/admin/AdminGuard").then((m) => ({ default: m.AdminGuard })),
);
const AdminLayout = lazy(() =>
  import("@/admin/AdminLayout").then((m) => ({ default: m.AdminLayout })),
);

export const Route = createFileRoute("/admin")({
  head: () => ({
    meta: [
      { title: "Administration · 2AM Hospitality" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminRoot,
});

function AdminRoot() {
  void Outlet;
  return (
    <Suspense fallback={null}>
      <AdminGuard>
        <AdminLayout />
      </AdminGuard>
    </Suspense>
  );
}
